import { AppPage } from 'common/Layout';
import { EducationPlanOop } from 'features/education-plan-oop';
import { useEducationPlanOopPage } from './use-education-plan-oop';

export const EducationPlanOopPage = () => {
  const { breadcrumbsLoading, breadcrumbs, educationPlan } = useEducationPlanOopPage();

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
        loading: breadcrumbsLoading,
      }}
      documentTitle={educationPlan?.name ?? 'Учебный план'}
    >
      <EducationPlanOop />
    </AppPage>
  );
};
